import { ImageCompression } from '../image-compression/image-compression';
import { PdfCompression } from '../pdf-compression/pdf-compression';

/* Punto único para comprimir los adjuntos de fórmula: fotos (JPEG/PNG) y PDF. */
export class FileCompression {

  static isCompressible(file: File): boolean {
    return ImageCompression.isCompressible(file) || PdfCompression.isCompressible(file);
  }

  static compress(file: File, maxBytes: number): Promise<File> {
    return PdfCompression.isCompressible(file)
      ? PdfCompression.compress(file, maxBytes)
      : ImageCompression.compress(file, maxBytes);
  }

  /** Mensaje específico del rechazo, si lo hay; si no, el componente muestra el genérico. */
  static userMessage(error: any): string {
    return PdfCompression.userMessage(error);
  }
}
